@if (page) {
  <div class="vertical-center">
    <app-route-page>
      <!-- Desktop View -->
      <div class="d-none d-md-flex justify-content-center desktop-view">
        <div class="d-flex flex-row justify-content-center psic-gap-6">
          <!-- Left Section -->
          <div class="d-flex flex-column justify-content-center">
            <div class="d-flex flex-column justify-content-center header-section">
              <img
                [src]="page.getField('image')?.icon_path"
                class="error-page-image w-100"
                alt="page.getField('image')?.icon_path"
                />
              </div>
            </div>
            <!-- Right Section -->
            <div class="d-flex flex-column justify-content-center content-section psic-gap-8">
              <div class="d-flex flex-column psic-gap-1">
                <h1 [innerHTML]="page.getFieldValue('heading')">{{ page.getFieldValue('heading') }}</h1>
                <p [innerHTML]="page.getFieldValue('subText')">{{ page.getFieldValue('subText') }}</p>
              </div>
              <ng-container>
                @if (page.getField('submitButton')) {
                  <lib-button
                    [buttonSize]="'small'"
                    [buttonText]="page.getFieldValue('submitButton')"
                    (callback)="pageNavigation(page.getField('submitButton')?.name, page!)"
                  ></lib-button>
                }
              </ng-container>
            </div>
          </div>
        </div>
        <!-- Mobile View -->
        <div class="d-flex flex-column d-md-none justify-content-center align-items-center psic-gap-8">
          <div class="d-flex flex-column psic-gap-4">
            <h3 [innerHTML]="page.getFieldValue('heading')" class="text-center">
              {{ page.getFieldValue('heading') }}
            </h3>
            <p [innerHTML]="page.getFieldValue('subText')" class="text-center">
              {{ page.getFieldValue('subText') }}
            </p>
          </div>
          <div class="text-center" style="width: 325px">
            <img [src]="page.getField('image')?.icon_path" class="w-100" alt="page.getField('image')?.icon_path" />
          </div>
        </div>
        <app-navigation-footer
          footer
          [goBack]="true"
          [showButton]="true"
          [continueButtonText]="page.getFieldValue('submitButton')"
          (navigatePage)="pageNavigation($event, page!)"
          >
        </app-navigation-footer>
      </app-route-page>
    </div>
  }
